import { NgTemplateOutlet } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DefaultTooltipComponent, TooltipDirective } from '@os-components';
import { SewWsRichtext } from '@sew/ui-components-angular/standalone';
import { SparePartAvailability } from '../../../../features/result/spare-parts-result/spare-parts.interface';
import { InventoryIndicatorComponent } from '../inventory-indicator/inventory-indicator.component';

@Component({
    selector: 'ecs-availability-cell',
    templateUrl: './availability-cell.component.html',
    styleUrls: ['./availability-cell.component.scss'],
    imports: [
        NgTemplateOutlet,
        InventoryIndicatorComponent,
        TooltipDirective,
        SewWsRichtext,
        DefaultTooltipComponent,
    ],
})
export class AvailabilityCellComponent {
    @Input() public availability?: SparePartAvailability;
}
